export default {
    logo: {
        width: 130,
        height: 'auto',
        marginBottom: 12
    },
    img: {
        maxWidth: '100%',
        height: 'auto',
        marginBottom: 8
    }
}



// WEBPACK FOOTER //
// ./src/views/PrintProduct/styles.js